import React from 'react';
import { Button, CircularProgress, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { LocalizationProvider, DateCalendar } from '@mui/x-date-pickers';
import { gridSizeMdLg12, gridSizeMdLg6, toHour } from '@/shared';
import dayjs from 'dayjs';
import { Refresh } from '@mui/icons-material';
import { texto } from '@/shared/utils';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useSelectDateTimerPreScheduling from './useSelectDateTimerPreScheduling.store';
import { CustomConfirmDialogProps } from '@/shared/components/ui/Dialogs';

const fmt = (ms: number) => {
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

/**
 * Props for DateTimeSelector component.
 * @param value - Fecha y hora inicial (opcional).
 * @param onChange - Callback cuando cambia la fecha u hora.
 */
interface DateTimeSelectorProps {
  value?: Date | null;
  onChange?: (value: Date | null) => void;
}

export const SelectDateTimerPreScheduling:
  React.FC<DateTimeSelectorProps> = ({

  }) => {

    const float = useSelectDateTimerPreScheduling(s => s.float);
    const remainingMs = useSelectDateTimerPreScheduling(s => s.remainingMs);
    const isLoadingPlanner = useSelectDateTimerPreScheduling(s => s.isLoadingPlanner);
    const modalConfirmBlocked = useSelectDateTimerPreScheduling(s => s.modalConfirmBlocked);
    const currentIndex = useSelectDateTimerPreScheduling(s => s.currentIndex);
    const blocked = useSelectDateTimerPreScheduling(s => s.blocked);
    const planner = useSelectDateTimerPreScheduling(s => s.planner);
    const setPlanner = useSelectDateTimerPreScheduling(s => s.setPlanner);
    const selectDate = useSelectDateTimerPreScheduling(s => s.selectDate);
    const setSelectDate = useSelectDateTimerPreScheduling(s => s.setSelectDate);
    const setCurrentIndex = useSelectDateTimerPreScheduling(s => s.setCurrentIndex);
    const handleVerificationPlanner = useSelectDateTimerPreScheduling(s => s.handleVerificationPlanner);
    const handleRefreshPlanner = useSelectDateTimerPreScheduling(s => s.handleRefreshPlanner);
    const handleConfirmedPlanner = useSelectDateTimerPreScheduling(s => s.handleConfirmedPlanner);
    const handleCloseModalConfirmBlocked = useSelectDateTimerPreScheduling(s => s.handleCloseModalConfirmBlocked);

    // Función para ir al siguiente técnico
    const handleNext = () => {
      if (currentIndex < float.length - 1) {
        setCurrentIndex(currentIndex + 1);
        setPlanner(float[currentIndex + 1].codigo)
        //form.setValue('flota', float[currentIndex + 1]?.codigo)
      }
    };

    // Función para ir al técnico anterior
    const handlePrev = () => {
      if (currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
        setPlanner(float[currentIndex - 1].codigo)
        //form.setValue('flota', float[currentIndex - 1]?.codigo)
      }
    };

    return (
      <>
        <Grid container spacing={3}>
          {
            blocked && (
              <Grid item xs={12}>
                <Typography variant='subtitle1'
                  style={{
                    textAlign: 'center'
                  }} >
                  Planificador bloqueado por {fmt(remainingMs)} min
                </Typography>

              </Grid>
            )
          }
          <Grid item xs={12}>

            <Grid container
              spacing={3}
              justifyContent={'space-between'}
              alignContent={'space-between'}
              sx={{
                pointerEvents: blocked ? 'none' : 'auto',
                borderRadius: 1,
                //p: 0.5,
                opacity: blocked ? 0.5 : '1',
                //backgroundColor: blocked ? '#e0e0e0ff' : 'inherit'
              }}
            >

              <Grid item xs={6}>
                <Button
                  fullWidth
                  onClick={handlePrev}
                  disabled={currentIndex === 0}
                  variant="contained"
                  color="primary"
                >
                  Regresar
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  fullWidth
                  onClick={handleNext}
                  disabled={currentIndex === float.length - 1}
                  variant="contained"
                  color="primary"
                >
                  Cambiar
                </Button>
              </Grid>

              <Grid {...gridSizeMdLg6} item >

                <Typography variant="subtitle1" sx={{ textAlign: 'start' }}>
                  Fechas disponibles
                </Typography>

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={"es"}
                >
                  <DateCalendar
                    value={selectDate}
                    minDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectDate(dayjs(newValue))
                    }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid {...gridSizeMdLg6} item container spacing={0}>

                <Grid item xs={10}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'start' }}>
                    Horas disponibles
                  </Typography>
                </Grid>


                <Grid item xs={2}>
                  <Tooltip title="Actualizar Horas" placement="top">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        handleRefreshPlanner()
                      }}
                    >
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </Grid>

                <Grid item {...gridSizeMdLg12}>

                  {
                    !isLoadingPlanner && planner ? (
                      <>
                        {
                          planner.horas.map((element, index) => {
                            return <Button
                              sx={{
                                margin: 0.3
                              }}
                              variant='contained'
                              key={`${element.hora}-${index}`}
                              disabled={element.estado}
                              color={element.estado
                                ? 'warning'
                                : 'primary'
                              }
                              onClick={() => {
                                handleVerificationPlanner(element)
                              }}
                            >
                              {
                                toHour(element.hora)
                              }
                            </Button>

                          })
                        }
                      </>
                    ) : (
                      <CircularProgress />
                    )
                  }

                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Grid>

        {
          <CustomConfirmDialogProps
            open={modalConfirmBlocked}
            title="Seleccionar horario de instalación"
            subtitle="¿Está seguro de querer agendar la instalacion en este horario?"
            text2={texto.mensaje_bloquar_horario_10_min}
            confirmTextBtn="Si, seleccionar horario"
            onClose={() =>
              handleCloseModalConfirmBlocked()
            }
            onConfirm={() =>
              handleConfirmedPlanner()
            }
          />
        }
      </>
    );
  };
